
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import FAQ from "./_faq.mdx";
import WHY from "./_whytradly.mdx";
import utilities from 'utilities?plugin=tableLayout'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Shipday Vs Tradly - Delivery Management",
  "date": "2022-07-24"
};
const slug = 'shipday-vs-tradly';
const tableOfContents = [{
  "title": "What is Delivery management?",
  "slug": "what-is-delivery-management",
  "children": []
}, {
  "title": "Shipday",
  "slug": "shipday",
  "children": []
}, {
  "title": "Feature Comparison",
  "slug": "feature-comparison",
  "children": []
}];
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Example = makeShortcode("Example");
const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <_Heading level={2} id={"what-is-delivery-management"} nextElement={{
      "type": "paragraph"
    }}>What is Delivery management?</_Heading>
    <p>{`Delivery management is the activity of using efficient logistics and digitally powered tools to ensure that the goods reach the end customer effectively and efficiently`}</p>
    <_Heading level={2} id={"shipday"} nextElement={{
      "type": "paragraph"
    }}>Shipday</_Heading>
    <p>{`Shipday is an easy-to-use software platform designed for restaurants, ghost kitchens, ultra-fast grocery deliveries, and other small businesses to manage local deliveries`}</p>
    <_Heading level={2} id={"feature-comparison"} nextElement={{
      "type": "jsx"
    }}>Feature Comparison</_Heading>
    <Example p="none" mdxType="Example">
  <div class="shadow-sm overflow-hidden my-8">
    <table class="border-collapse table-auto w-full text-lg">
          <thead>
  <tr>
    <th>features</th>
    <th>Tradly</th>
    <th>Shipday</th>
  </tr>
          </thead>
          <tbody>
  <tr>
    <td>orders per month services </td>
    <td>YES</td>
    <td>YES</td>
  </tr>
  <tr>
    <td>additional orders service </td>
    <td> X </td>
    <td>NO</td>
  </tr>
  <tr>
    <td>adding fleet</td>
    <td>YES</td>
    <td>NO</td>
  </tr>
  <tr>
    <td>roaster creation </td>
    <td>YES</td>
    <td>NO</td>
  </tr>
  <tr>
    <td>drivers </td>
    <td>YES</td>
    <td>NO</td>
  </tr>
  <tr>
    <td>dashboard preview </td>
    <td>YES</td>
    <td>NO</td>
  </tr>
  <tr>
    <td>genrate reports </td>
    <td>YES</td>
    <td>NO</td>
  </tr>
  <tr>
    <td>Automated order entry</td>
    <td>YES</td>
    <td>YES</td>
  </tr>
  <tr>
    <td>Online order forms</td>
    <td> X </td>
    <td>YES</td>
  </tr>
  <tr>
    <td>real-time location tracking</td>
    <td>YES</td>
    <td>YES</td>
  </tr>
  <tr>
    <td>Multi-user access</td>
    <td>YES</td>
    <td>NO</td>
  </tr>
  <tr>
    <td>route optimization </td>
    <td> X </td>
    <td>NO</td>
  </tr>
  <tr>
    <td>3rd party delivery services</td>
    <td> X </td>
    <td>YES</td>
  </tr>
  <tr>
    <td>Proof of delivery</td>
    <td>NA </td>
    <td>YES</td>
  </tr>
  <tr>
    <td>recept to customers via mail or text </td>
    <td>NA </td>
    <td>YES</td>
  </tr>
  <tr>
    <td>Real-time delivery tracking for customers</td>
    <td> X </td>
    <td>YES</td>
  </tr>
  <tr>
    <td>notifications to customers with live ETA</td>
    <td>YES</td>
    <td>NO</td>
  </tr>
  <tr>
    <td>Delivery tracking for customers on map</td>
    <td> X </td>
    <td>NO</td>
  </tr>
  <tr>
    <td>Email support</td>
    <td> X </td>
    <td>YES</td>
  </tr>
          </tbody>
        </table>      </div>
    </Example>
```



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
